import { Component, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormArray,
  AbstractControl
} from '@angular/forms';

@Component({
  selector: 'app-base',
  template: '',
  standalone: false
})
export class BaseComponent implements OnInit {
  constructor() {}

  public cardExpanders = {};
  // NOTE: this message may need to change when other types of locks
  // are handled on the person editor form
  public clientLockMsg = 'View Only - Payroll In Progress';
  public sortKey: string;
  public sortDirection: string;
  public weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  ngOnInit() {}

  public disableAllFormControls(form: UntypedFormGroup) {
    Object.keys(form.controls).forEach(ctrl => {
      form.controls[ctrl].disable({ emitEvent: false });
    });
  }

  public getDayOfWeek(date: Date) {
    if (date === null || date === undefined) {
      return '';
    }

    if (typeof date === 'string') {
      date = new Date(date);
    }

    return this.weekdays[date.getDay()];
  }

  public markArrayTouched(formArray: UntypedFormArray) {
    formArray.controls.forEach(control => {
      switch (control.constructor.name) {
        case 'FormGroup':
          this.markGroupTouched(control as UntypedFormGroup);
          break;
        case 'FormArray':
          this.markArrayTouched(control as UntypedFormArray);
          break;
        case 'FormControl':
        default:
          this.markControlTouched(control as UntypedFormControl);
          break;
      }
    });
  }

  public markControlTouched(formControl: UntypedFormControl) {
    formControl.markAsTouched();
  }

  public markControlsAsTouched(controls: { [key: string]: AbstractControl }) {
    Object.keys(controls).forEach(ctrl => {
      controls[ctrl].markAsTouched();
    });
  }

  // call this from the child component when validating form.
  // marking an invalid control as touched flips on
  // field level error rendering, so user knows why they can't save yet.
  // this can also handle complex/nested FormGroup/FormArray structures.
  public markGroupTouched(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      // FIXME: the functionality below of grabbing the constructor name
      // no longer works when published.
      // constructor name changes from "FormControl" to "Tw"....
      // result will be that nested form arrays will not mark the controls as
      // touched properly. as of 2021-02-08 this is only used on person > local taxes
      switch (formGroup.get(key).constructor.name) {
        case 'FormGroup':
          this.markGroupTouched(formGroup.get(key) as UntypedFormGroup);
          break;
        case 'FormArray':
          this.markArrayTouched(formGroup.get(key) as UntypedFormArray);
          break;
        case 'FormControl':
        default:
          this.markControlTouched(formGroup.get(key) as UntypedFormControl);
          break;
      }
    });
  }

  // if collection.length === 1 value is returned,
  // else for regular plurals suffix is applied and returned
  //      for irregular plurals such as person -> people, suffix replaces value completely
  //      e.g. pluralize('matrix', this.keanuReeves.movies, 'matrices', true);
  public pluralize(value: string, length, suffix: string, irregular: boolean = false) {
    let suffixed = irregular ? suffix : `${value}${suffix}`;
    return length === 1 ? value : suffixed;
  }

  public removeThClass(tableId, className: string) {
    const table = document.getElementById(tableId);
    const elems = table.getElementsByClassName(className);

    for (let i = 0; i < elems.length; i++) {
      elems[i].classList.remove(className);
    }
  }

  public scrollToInvalidFormElement(formGroup: UntypedFormGroup) {
    let e: HTMLElement;
    Object.keys(formGroup.controls).forEach(x => {
      if (formGroup.controls[x].invalid && !e) {
        let ctrl = formGroup.controls[x] as any;
        console.log(ctrl);
        if (ctrl.nativeElement) {
          e = ctrl.nativeElement;
        }
      }
    });

    if (e) {
      // FIXME: collapse any expanded cards
      e.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
    }
  }

  public sortTableBy(event, tableId, column) {
    // check to see if same column or new column was clicked
    if (this.sortKey !== column) {
      this.removeThClass(tableId, 'asc');
      this.removeThClass(tableId, 'desc');
      this.sortKey = column;
    }

    // default to ascending order
    if (!this.sortDirection || this.sortDirection === 'desc') {
      this.sortDirection = 'asc';
      event.target.classList.add('asc');
      event.target.classList.remove('desc');
    } else {
      this.sortDirection = 'desc';
      event.target.classList.add('desc');
      event.target.classList.remove('asc');
    }
  }

  // check if the string passed in the 1st argument
  // contains the string of 2nd arg. used in templates
  public stringContains(stringToCheck, fragment) {
    if (stringToCheck && typeof stringToCheck === 'string') {
      return stringToCheck.indexOf(fragment) > -1;
    } else {
      return false;
    }
  }

  public toggleCardExpand(key) {
    // close any other expanded cards
    Object.keys(this.cardExpanders).forEach(k => {
      if (key !== k && this.cardExpanders[k]) {
        this.cardExpanders[k] = false;
      }
    });

    if (!this.cardExpanders[key]) {
      this.cardExpanders[key] = true;
    } else {
      this.cardExpanders[key] = !this.cardExpanders[key];
    }
  }
}
